module.exports = function reducer_Teaser(state = {}) {
    return state;
};
